import FramePageInner from 'common/view/layouts/frames/FramePageInner';
import { useBodyId } from 'hooks/common/CommonHook';
import { Outlet } from 'react-router-dom';

const SampleContactLayout = () => {
  useBodyId('contact');
  return (
    <FramePageInner>
      <Outlet />
    </FramePageInner>
  );
};

export default SampleContactLayout;
